import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type10MixedUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type10Mixed", configService);
    }
}
